import { useEffect } from 'react';

/// Components
import Index from './jsx';
import { connect } from 'react-redux';
import {
  Route,
  Routes,
  useLocation,
  useNavigate,
  useParams,
} from 'react-router-dom';
// Style
import './vendor/bootstrap-select/dist/css/bootstrap-select.min.css';
import './css/style.css';
import { AuthActions } from '@adapters/redux/reducer/auth';
import GlobalLoader from '@jsx/components/Loader/GlobalLoader';

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return <Component {...props} router={{ location, navigate, params }} />;
  }

  return ComponentWithRouterProp;
}

function App(props) {
  const navigate = useNavigate();

  useEffect(() => {
    props.checkAuthenticated(navigate);
  }, []);

  if (!props.isAppReady) return <GlobalLoader />;

  return <Index />;
}

const mapStateToProps = (state) => ({
  isAppReady: state.auth.isAppReady,
});
const mapDispatchToProps = (dispatch) => ({
  checkAuthenticated: (navigate) => dispatch(AuthActions.connect(navigate)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
